import { render, staticRenderFns } from "./SectionAuthor.vue?vue&type=template&id=205ac754&"
import script from "./SectionAuthor.vue?vue&type=script&lang=js&"
export * from "./SectionAuthor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports